import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { formatPercent, formatVolume } from '../../../utils/numberFormatFunc';

const DesktopTable = ({ ticker, expiration, modalRowData, upperData }) => {
  return (
    <Table>
      <TableHead>
        <TableRow style={{ backgroundColor: '#043055' }}>
          <TableCell
            style={{ color: 'white', fontSize: 18, width: '40%' }}
            align="center"
          >
            OPTION
          </TableCell>
          <TableCell
            style={{ color: 'white', fontSize: 18, width: '10%' }}
            align="center"
          >
            VOL
          </TableCell>
          <TableCell
            style={{ color: 'white', fontSize: 18, width: '10%' }}
            align="center"
          >
            OI
          </TableCell>
          <TableCell style={{ color: 'white', fontSize: 18 }} align="center">
            IVOL
          </TableCell>
          <TableCell style={{ color: 'white', fontSize: 18 }} align="center">
            CHG
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {upperData && Object.keys(upperData).length ? (
          <TableRow key={ticker}>
            <TableCell style={{ fontSize: 18, width: '40%' }} align="center">
              {ticker +
                ' ' +
                (expiration ? moment(expiration).format('DD-MMM-YY') : '') +
                ' $' +
                modalRowData.strike +
                ` ${modalRowData.put_call === 'P' ? ' Puts' : ' Calls'}`}
            </TableCell>
            <TableCell style={{ fontSize: 18, width: '10%' }} align="center">
              {formatVolume(upperData.volume)}
            </TableCell>
            <TableCell style={{ fontSize: 18, width: '10%' }} align="center">
              {formatVolume(upperData.open_int)}
            </TableCell>
            <TableCell align="center" style={{ fontSize: 18, width: '10%' }}>
              {formatPercent(upperData.ivol)}%
            </TableCell>
            <TableCell align="center" style={{ fontSize: 18, width: '10%' }}>
              <span
                style={
                  upperData.ivol_chg > 0 ? { color: 'green' } : { color: 'red' }
                }
              >
                {upperData.ivol_chg > 0
                  ? '+' +
                    (Math.round(upperData.ivol_chg * 1000) / 10).toFixed(1)
                  : (Math.round(upperData.ivol_chg * 1000) / 10).toFixed(1)}
              </span>
            </TableCell>
          </TableRow>
        ) : (
          'Please Wait'
        )}
      </TableBody>
    </Table>
  );
};

export default DesktopTable;



// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/DesktopTable.jsx